import { __decorate, __extends } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
var FormDiv = /** @class */ (function (_super) {
    __extends(FormDiv, _super);
    function FormDiv() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FormDiv.prototype, "className", {
        get: function () {
            var _a;
            return (_a = this.props.class) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormDiv.prototype, "style", {
        get: function () {
            var _a;
            return (_a = this.props.style) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ default: function () { return ({}); } })
    ], FormDiv.prototype, "props", void 0);
    FormDiv = __decorate([
        Component
    ], FormDiv);
    return FormDiv;
}(Vue));
export default FormDiv;
